<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalSchoolCertificatesSubMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "#",
                title: "Certificate Generation",
                description: "Create and issue certificates for eligible students.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Verification",
                description: "Verify certificates and confirm their authenticity.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
